import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_JOINT_VISIT_REPORT_API} from '@app/reactQuery/apis/constants';

export const RQUseGetJointVisitReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_joint_visit_report_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_JOINT_VISIT_REPORT_API,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};
